import { Layer, Position } from '@deck.gl/core';
import { ArcLayer } from '@deck.gl/layers';
import { parseColor255 } from '@fe/core';
import { CityPairSettings } from './types';

export type CityPairItem = {
    from: { id: string; icao?: string; iata?: string; position: Position };
    to: { id: string; icao?: string; iata?: string; position: Position };
    flights: string[];
    status: 'active' | 'planned' | 'scheduled';
};

//https://github.com/visgl/deck.gl/issues/9592#issuecomment-4279289039
export function deckCityPairLayer(traffic: CityPairItem[], settings: CityPairSettings): Layer[] {
    const activeColor = parseColor255(settings.activeColor);
    const plannedColor = parseColor255(settings.plannedColor);
    const scheduledColor = parseColor255(settings.scheduledColor);

    // This can be costly
    const filtered = traffic.filter(
        (x) =>
            (settings.active && x.status === 'active') ||
            (settings.planned && x.status === 'planned') ||
            (settings.scheduled && x.status === 'scheduled')
    );

    return [
        new ArcLayer<CityPairItem>({
            id: 'city-pair',
            greatCircle: true,
            data: filtered,
            pickable: true,
            autoHighlight: true,
            antialiasing: true,
            highlightColor: [255, 255, 0],
            getSourcePosition: (x) => x.from.position,
            getTargetPosition: (x) => x.to.position,
            getSourceColor: (x) => (x.status === 'active' ? activeColor : x.status === 'scheduled' ? scheduledColor : plannedColor),
            getTargetColor: (x) => (x.status === 'active' ? activeColor : x.status === 'scheduled' ? scheduledColor : plannedColor),
            getWidth: (x) => x.flights.length,
            getHeight: 0.5,
            parameters: { cullMode: 'none' }
        })
    ];
}
